"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CORSRules_1 = require("./_CORSRules");
exports._CORSConfiguration = {
    type: "structure",
    required: ["CORSRules"],
    members: {
        CORSRules: {
            shape: _CORSRules_1._CORSRules,
            locationName: "CORSRule"
        }
    }
};
//# sourceMappingURL=_CORSConfiguration.js.map